(function (module) {
    "use strict";
    module.service('LocaleService', ['$translate', 'AppConstant', '$rootScope', 'tmhDynamicLocale', LocaleService]);
    function LocaleService($translate, AppConstant, $rootScope, tmhDynamicLocale) {
        var service = this;
        service.setLocale = function (locale) {
            if (!service.checkLocaleIsValid(locale)) {
                console.error('Locale name "' + locale + '" is invalid');
                return;
            }
            $translate.use(locale);
        };

        service.checkLocaleIsValid = function (locale) {
            return _locales.indexOf(locale) !== -1;
        };

        var localeObj = AppConstant.Locales.locales;
        var _locales = Object.keys(localeObj);
        if (!_locales || _locales.length === 0) {
            console.error('No locales');
        }

        var _localesDisplayNames = [];
        angular.forEach(_locales, function (locale) {
            _localesDisplayNames.push(localeObj[locale]);
        });

        $rootScope.$on('$translateChangeSuccess', function (event, data) {
            document.documentElement.setAttribute('lang', data.language);
            tmhDynamicLocale.set(data.language.toLowerCase().replace(/_/g, '-'));
        });

        service.getLocaleDisplayName = function () {
            return AppConstant.Locales.locales[$translate.proposedLanguage()];
        };
        service.setLocaleByDisplayName = function (localeDisplayName) {
            service.setLocale(_locales[_localesDisplayNames.indexOf(localeDisplayName)]);
        };
        service.getLocaleDisplayNames = function () {
            return _localesDisplayNames;
        };
    }
})(angular.module("Locale.module", []));